import useAccountQuery from "@/shared/hooks/useAccountQuery";
import { markMockSystemMessageSeen } from "@/shared/queries/systemMessages/mock/systemMessagesMock";
import { useMutation } from "@tanstack/react-query";

// Tells the backend the user has seen a message so it is not shown again
const useSystemMessageSeenPost = () => {
  const { data: account } = useAccountQuery();

  return useMutation<void, Error, number>({
    // TODO: replace with the real endpoint once it exists, e.g.
    // post2(`internal/secure/pos/v1/system-messages/${id}/seen`)
    mutationFn: (id) => markMockSystemMessageSeen(account?.item_id, id),
  });
};

export default useSystemMessageSeenPost;
